import React, { useState } from "react";
import "./LoginPage.css";
import { userLogin } from '../../_services/authServices'
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';

import { useUser } from "../../context/UserContext";
import {toast } from "react-hot-toast";

const LoginPage = () => {
  const navigate = useNavigate();
  const { user, login } = useUser();
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [emailAddress, setEmail] = useState('');
  const [password, setPassword] = useState('');

  if(user) {
    navigate("/choose-profile", {replace: true})
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
  
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
  
    setLoading(true);
    setValidated(true);
  
    try {
      const result = await userLogin(emailAddress, password);
      setEmail("");
      setPassword("");
      
      const user = result.data.user;

      login(user);
      
      toast.success("Login Successful.");

      if(result.data.user.status === "ACTIVE") {
        navigate(`/choose-profile`, { replace: true });
      }else{
        navigate(`/update-password`, { replace: true });
      }
    } catch (error) {
      toast.error(error.message || `Something went wrong. Please try again.`);
    } finally {
      setLoading(false);
    }
  };
    
    
  return (
    <div className="login-wrapper">

      <Loader show={loading} message="Authenticating, please wait..." />
      
      <div className="login-card">
        
        {/* Logo */}
        <div className="logo-container">
          <img src="/images/logo.png" alt="Logo" />
        </div>

        <p className="subtitle">Sign in to continue</p>

        {/* Form */}
        <form method="post" onSubmit={handleLogin} className="login-form">
          
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={emailAddress}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="options">
            <label>
              <input type="checkbox" /> Remember me
            </label>

            <a href="/forgot-password" className="forgot">
              Forgot password?
            </a>
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>

          <p className="register-text">
            Don’t have an account?{" "}
            <a href="/register">Create account</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;